<template>
    <div class="templ">
        <div class="sidebar-form">
            <div class="input-group">
                <input type="text" v-model="search" name="q" class="form-control" placeholder="Buscar paciente...">
                <span class="input-group-btn">
                    <button type="button" @click="debouncedGetAnswer(search)" class="btn btn-flat"><i class="fa fa-search"></i></button>
                </span>
            </div>
        </div>
        <dropdown class="dropSearchMenu" ref="dropdown" v-model="show">
            <template slot="dropdown">
                <li class="searchMenu" v-for="p in people" :key="p.id">
                    <a :href="'/patient/'+ p.id +'/edit'">
                        <h5 class="message-title">{{p.code}} | {{p.name}} - {{p.identification1}}</h5>
                    </a>
                </li>
                <li class="searchMenu" v-if="!people.length">
                    <a href="javascript:void(0)">
                        <h5 class="message-title">NENHUM PACIENTE ENCONTRADO</h5>
                    </a>
                </li>                
            </template>
        </dropdown>
    </div>
</template>

<script>

    export default {
        name: "TopBarSearch",

        data(){
            return {
                show: false,
                search:'',
                people:[],
            }
        },

        watch: {
            search: function (searchVal) {
                // console.log('Esperando você terminar de digitar...')
                if(searchVal)
                    this.debouncedGetAnswer(searchVal)
                else
                    this.show = false
            },
        },

        methods: {
            getSearchResult: function (searchVal) {
                axios.post('/patient/search', {'kw': searchVal})
                    .then(function (response) {
                        this.people = response.data;
                        this.show = true
                    }.bind(this))
                    .catch(function (error) {
                        console.log(error)
                    })
            },

            closePopup(){
                this.display = 'none';
            },
        },

        created() {
            // _.debounce é uma função fornecida pelo lodash para limitar a frequência que uma operação complexa pode ser executada.
            // Neste caso, queremos limitar a frequência com que acessamos a api, esperando que o usuário termine completamente
            // a digitação antes de realizar a chamada Ajax. Para aprender mais sobre a função _.debounce (e sua prima _.throttle),
            // visite: https://lodash.com/docs#debounce
            this.debouncedGetAnswer = _.debounce(this.getSearchResult, 500)
        },
    }
</script>

<style>
    .templ{
        margin-bottom: -20px;
    }
    .searchMenu{
        width: 500px;
    }
    .dropSearchMenu{
        margin-top: -35px;
        margin-left: 15px;
    }
</style>